// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import "./assets/libs/@mdi/font/css/materialdesignicons.min.css";
// import BrandPage from "./pages/brand";
// import ContactPage from "./pages/contact";
// import AboutPage from "./pages/about";
// import PricingPage from "./pages/pricing";
// import "@fortawesome/fontawesome-free/css/all.min.css";
// import ContactSales from "./pages/ContactSales";
// import ScrollToTop from "./ScrollToTop";
// import HomePage from "./pages/HomePage";
// import ContactSupport from "./pages/contactSupport";
// import Partners from "./pages/Partners";
// import PartnerForm from "./pages/PartnerForm";
// import TermsAndConditions from "./pages/Policy/TermsAndConditions";
// import CancellationRefundPolicy from "./pages/Policy/CancellationRefundPolicy";
// import WaitList from "./pages/WaitList";
// import PrivacyPolicy from "./pages/Policy/PrivacyPolicy";
// import Careers from "./pages/Careers";
// import { HelmetProvider } from "react-helmet-async";
// import { Features } from "./pages/Features";
// import "./assets/css/custom.css";
// import "./assets/css/my_custom.css";
// import Documenttt from "../src/pages/Document";
// import JobDetails from "./pages/JobDetails";
// import AdminTreeView from "./component/Docs/DocsTabs/AdminTreeView";
// import PublicChangeLog from "./component/Docs/PublicChangeLog/PublicChangeLog";
// import TeamCollaborationFeature from "./component/workflow/Features/TeamCollaborationFeature";
// import CustomDashboardFeature from "./component/workflow/Features/CustomDashboardFeature";
// import SmartSchedulingCalendar from "./component/workflow/Features/SmartSchedulingCalendar";
// import DocumentsOrganized from "./component/workflow/Features/DocumentsOrganized";
// import OfficeHub from "./pages/OfficeHub";
// import TaskManagement from "./pages/TaskManagement";
// import DocsHome from "./component/Docs/Ruf/DocsHeroSection";
// import DocsPage from "./component/Docs/DocsTabs/DocsPage";
// import DocsLayoutLinear from "./component/Docs/Ruf/DocsLayoutLinear";
// import DocsHomeLinear from "./component/Docs/DocsTabs/DocsHomeLinear";
// import DocsLayout from "./component/Docs/DocsTabs/DocsLayout";
// import InstanceMessage from "./pages/InstanceMessage";
// import { useEffect } from "react";
// import Aos from "aos";
// import BulkAction from "./pages/BulkAction";
// import { ToastContainer } from "react-toastify";
// import SecurityPage from "./pages/security/SecurityPage";
// import RouteSEO from "./config/RouteSEO";

// export default function App() {
//   useEffect(function () {
//     Aos.init({ duration: 10000 });
//   }, []);
//   return (
//     <HelmetProvider>
//       <ToastContainer />
//       <BrowserRouter basename="/">
//         <ScrollToTop />
//         <Routes>
//           <Route exact path="/" element={<HomePage />} />
//           {/* <Route path="/docs/:id" element={<DocsPage />} /> */}
//           <Route path="/docs" element={<DocsLayout />}>
//             {/* /docs */}
//             <Route index element={<DocsHomeLinear />} />

//             {/* /docs/:id */}
//             <Route path=":id" element={<DocsPage />} />
//           </Route>
//           {/* <Route exact path="/docs" element={<DocsHome />} /> */}
//           {/* This is Testing Comment */}
//           <Route
//             exact
//             path="//features/team-workflow"
//             element={<TeamCollaborationFeature />}
//           />
//           <Route
//             exact
//             path="/customdashboard"
//             element={<CustomDashboardFeature />}
//           />

//           <Route
//             exact
//             path="/smartscheduling"
//             element={<SmartSchedulingCalendar />}
//           />
//           <Route
//             exact
//             path="/documentsorganized"
//             element={<DocumentsOrganized />}
//           />
//           <Route exact path="/security" element={<SecurityPage />} />
//           <Route exact path="/instancemessage" element={<InstanceMessage />} />
//           <Route exact path="/brand" element={<BrandPage />} />
//           <Route exact path="/contact" element={<ContactPage />} />
//           <Route exact path="/about" element={<AboutPage />} />
//           <Route exact path="/pricing" element={<PricingPage />} />
//           <Route exact path="/contactsales" element={<ContactSales />} />
//           <Route exact path="/bulkActionsCoherent" element={<BulkAction />} />
//           <Route exact path="/features" element={<Features />} />
//           {/* <Route exact path="/docs" element={<Documenttt />} /> */}
//           {/* <Route exact path="/docsHome" element={<DocsHome />} /> */}
//           <Route exact path="/Admin_Docs" element={<AdminTreeView />} />

//           <Route exact path="/contactsupport" element={<ContactSupport />} />
//           <Route exact path="/partners" element={<Partners />} />
//           <Route exact path="/partnerform" element={<PartnerForm />} />
//           <Route exact path="/terms" element={<TermsAndConditions />} />
//           <Route exact path="/careers" element={<Careers />} />
//           <Route path="/careers/:id" element={<JobDetails />} />
//           <Route
//             exact
//             path="/policy-refund"
//             element={<CancellationRefundPolicy />}
//           />

//           {/* <Route path="/docs" element={<DocsLayoutLinear />}>
//             <Route index element={<DocsHomeLinear />} />
//             <Route path=":id" element={<DocsPage />} /> */}
//           {/* </Route> */}
//           <Route exact path="/publiclog" element={<PublicChangeLog />} />
//           <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
//           <Route exact path="/waitlist" element={<WaitList />} />
//           <Route exact path="/office-hub" element={<OfficeHub />} />
//           <Route exact path="/taskmanagement" element={<TaskManagement />} />
//         </Routes>
//       </BrowserRouter>
//     </HelmetProvider>
//   );
// }

import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./assets/libs/@mdi/font/css/materialdesignicons.min.css";
import BrandPage from "./pages/brand";
import ContactPage from "./pages/contact";
import AboutPage from "./pages/about";
import PricingPage from "./pages/pricing";
import "@fortawesome/fontawesome-free/css/all.min.css";
import ContactSales from "./pages/ContactSales";
import ScrollToTop from "./ScrollToTop";
import HomePage from "./pages/HomePage";
import ContactSupport from "./pages/contactSupport";
import Partners from "./pages/Partners";
import PartnerForm from "./pages/PartnerForm";
import TermsAndConditions from "./pages/Policy/TermsAndConditions";
import CancellationRefundPolicy from "./pages/Policy/CancellationRefundPolicy";
import WaitList from "./pages/WaitList";
import PrivacyPolicy from "./pages/Policy/PrivacyPolicy";
import Careers from "./pages/Careers";
import { HelmetProvider } from "react-helmet-async";
import { Features } from "./pages/Features";
import "./assets/css/custom.css";
import "./assets/css/my_custom.css";
import Documenttt from "../src/pages/Document";
import JobDetails from "./pages/JobDetails";
import AdminTreeView from "./component/Docs/DocsTabs/AdminTreeView";
import PublicChangeLog from "./component/Docs/PublicChangeLog/PublicChangeLog";
import TeamCollaborationFeature from "./component/workflow/Features/TeamCollaborationFeature";
import CustomDashboardFeature from "./component/workflow/Features/CustomDashboardFeature";
import SmartSchedulingCalendar from "./component/workflow/Features/SmartSchedulingCalendar";
import DocumentsOrganized from "./component/workflow/Features/DocumentsOrganized";
import OfficeHub from "./pages/OfficeHub";
import TaskManagement from "./pages/TaskManagement";
import DocsHome from "./component/Docs/Ruf/DocsHeroSection";
import DocsPage from "./component/Docs/DocsTabs/DocsPage";
import DocsLayoutLinear from "./component/Docs/Ruf/DocsLayoutLinear";
import DocsHomeLinear from "./component/Docs/DocsTabs/DocsHomeLinear";
import DocsLayout from "./component/Docs/DocsTabs/DocsLayout";
import InstanceMessage from "./pages/InstanceMessage";
import { useEffect } from "react";
import Aos from "aos";
import BulkAction from "./pages/BulkAction";
import { ToastContainer } from "react-toastify";
import SecurityPage from "./pages/security/SecurityPage";
import RouteSEO from "./config/RouteSEO"; // Make sure this path is correct
import TestMeta from "./config/TestMeta";
import DocsWrapper from "./component/Docs/DocsTabs/DocsWrapper";
import { DataProvider } from "./OnBoard/DaysContext";
import CAFirmsPage from "./pages/About/CAFirmsPage";
import LegalTeamsPage from "./pages/About/LegalTeamsPage";
import ITServicesPage from "./pages/About/ITServicesPage";
import PharmaCompaniesPage from "./pages/About/PharmaCompaniesPage";
import HealthcareProvidersPage from "./pages/About/HealthcareProvidersPage";
import ConsultingAgenciesPage from "./pages/About/ConsultingAgenciesPage";
import RealEstatePage from "./pages/About/RealEstatePage";
import MarketingAgenciesPage from "./pages/About/MarketingAgenciesPage";
import ManufacturingPage from "./pages/About/ManufacturingPage";
import ArchitectureFirmsPage from "./pages/About/ArchitectureFirmsPage";
import WhatsAppButton from "./component/WhatsAppButton";
import DemoLeadPopup from "./component/DemoLeadPopup";
import CAFirmsSolutionPage from "./pages/solutions/CAFirmsSolutionPage";
import TaxConsultantsPage from "./pages/solutions/TaxConsultantsPage";
import AdvocatesPage from "./pages/solutions/AdvocatesPage";
import ProfessionalServicesPage from "./pages/solutions/ProfessionalServicesPage";
import ClientWiseWorkTracking from "./pages/features/ClientWiseWorkTracking";
import FYPeriodTracking from "./pages/features/FYPeriodTracking";
import DocumentCollection from "./pages/features/DocumentCollection";
import ReviewApprovalWorkflow from "./pages/features/ReviewApprovalWorkflow";
import DeadlineReminders from "./pages/features/DeadlineReminders";
import ClosureProof from "./pages/features/ClosureProof";
import AuditTrail from "./pages/features/AuditTrail";
import ExcelVsSimplifyte from "./pages/compare/ExcelVsSimplifyte";
import WhatsAppVsSimplifyte from "./pages/compare/WhatsAppVsSimplifyte";
import GenericTaskToolsVsSimplifyte from "./pages/compare/GenericTaskToolsVsSimplifyte";
import CACommunity from "./pages/CACommunity";
import McpIntegration from "./pages/features/McpIntegration";

export default function App() {
  useEffect(function () {
    Aos.init({ duration: 10000 });
  }, []);

  return (
    <HelmetProvider>
      <ToastContainer />
      <WhatsAppButton />
      <DemoLeadPopup />
      <DataProvider>
        <BrowserRouter basename="/">
          <ScrollToTop />
          {/* <TestMeta /> */}
          <Routes>
            {/* Home Route */}
            <Route
              exact
              path="/"
              element={
                <RouteSEO>
                  <HomePage />
                </RouteSEO>
              }
            />

            {/* Docs Routes */}
            <Route
              path="/docs"
              element={
                <RouteSEO>
                  <DocsLayout />
                </RouteSEO>
              }
            >
              <Route index element={<DocsHomeLinear />} />
              {/* <Route index element={<DocsWrapper />} /> */}
              <Route path=":slug" element={<DocsPage />} />
            </Route>

            {/* Academy Route (if you have a separate academy page) */}
            <Route
              exact
              path="/academy"
              element={
                <RouteSEO>
                  <DocsHomeLinear /> {/* Or your academy component */}
                </RouteSEO>
              }
            />

            {/* Feature Routes */}
            <Route
              exact
              path="/features/team-workflow"
              element={
                <RouteSEO>
                  <TeamCollaborationFeature />
                </RouteSEO>
              }
            />

            <Route
              exact
              path="/features/custom-dashboard"
              element={
                <RouteSEO>
                  <CustomDashboardFeature />
                </RouteSEO>
              }
            />

            <Route
              exact
              path="/features/smart-scheduling"
              element={
                <RouteSEO>
                  <SmartSchedulingCalendar />
                </RouteSEO>
              }
            />

            <Route
              exact
              path="/features/document-management"
              element={
                <RouteSEO>
                  <DocumentsOrganized />
                </RouteSEO>
              }
            />

            {/* Main Pages */}
            <Route
              exact
              path="/security"
              element={
                <RouteSEO>
                  <SecurityPage />
                </RouteSEO>
              }
            />

            <Route
              exact
              path="/features/instant-messaging"
              element={
                <RouteSEO>
                  <InstanceMessage />
                </RouteSEO>
              }
            />

            <Route
              exact
              path="/brand"
              element={
                <RouteSEO>
                  <BrandPage />
                </RouteSEO>
              }
            />

            <Route
              exact
              path="/contact"
              element={
                <RouteSEO>
                  <ContactPage />
                </RouteSEO>
              }
            />

            <Route
              exact
              path="/about"
              element={
                <RouteSEO>
                  <AboutPage />
                </RouteSEO>
              }
            />

            <Route
              exact
              path="/pricing"
              element={
                <RouteSEO>
                  <PricingPage />
                </RouteSEO>
              }
            />

            <Route
              exact
              path="/contactsales"
              element={
                <RouteSEO>
                  <ContactSales />
                </RouteSEO>
              }
            />

            <Route
              exact
              path="/bulkActionsCoherent"
              element={
                <RouteSEO>
                  <BulkAction />
                </RouteSEO>
              }
            />

            <Route
              exact
              path="/features"
              element={
                <RouteSEO>
                  <Features />
                </RouteSEO>
              }
            />

            {/* Admin Routes - These might not need SEO, but wrapped for consistency */}
            <Route
              exact
              path="/Admin_Docs"
              element={
                <RouteSEO>
                  <AdminTreeView />
                </RouteSEO>
              }
            />

            {/* Support & Contact Routes */}
            <Route
              exact
              path="/contactsupport"
              element={
                <RouteSEO>
                  <ContactSupport />
                </RouteSEO>
              }
            />

            <Route
              exact
              path="/partners"
              element={
                <RouteSEO>
                  <Partners />
                </RouteSEO>
              }
            />

            <Route
              exact
              path="/partnerform"
              element={
                <RouteSEO>
                  <PartnerForm />
                </RouteSEO>
              }
            />

            {/* Legal Pages */}
            <Route
              exact
              path="/terms"
              element={
                <RouteSEO>
                  <TermsAndConditions />
                </RouteSEO>
              }
            />

            <Route
              exact
              path="/privacy-policy"
              element={
                <RouteSEO>
                  <PrivacyPolicy />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/ca-firms"
              element={
                <RouteSEO>
                  <CAFirmsPage />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/ca-community"
              element={
                <RouteSEO>
                  <CACommunity />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/legal-teams"
              element={
                <RouteSEO>
                  <LegalTeamsPage />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/it-services"
              element={
                <RouteSEO>
                  <ITServicesPage />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/pharma-companies"
              element={
                <RouteSEO>
                  <PharmaCompaniesPage />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/healthcare-providers"
              element={
                <RouteSEO>
                  <HealthcareProvidersPage />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/consulting-agencies"
              element={
                <RouteSEO>
                  <ConsultingAgenciesPage />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/real-estate"
              element={
                <RouteSEO>
                  <RealEstatePage />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/marketing-agencies"
              element={
                <RouteSEO>
                  <MarketingAgenciesPage />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/manufacturing"
              element={
                <RouteSEO>
                  <ManufacturingPage />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/architecture-firms"
              element={
                <RouteSEO>
                  <ArchitectureFirmsPage />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/policy-refund"
              element={
                <RouteSEO>
                  <CancellationRefundPolicy />
                </RouteSEO>
              }
            />

            {/* Careers Routes */}
            <Route
              exact
              path="/careers"
              element={
                <RouteSEO>
                  <Careers />
                </RouteSEO>
              }
            />

            <Route
              path="/careers/:id"
              element={
                <RouteSEO>
                  <JobDetails />
                </RouteSEO>
              }
            />

            {/* Changelog/Public Log */}
            <Route
              exact
              path="/changelog"
              element={
                <RouteSEO>
                  <PublicChangeLog />
                </RouteSEO>
              }
            />

            {/* <Route
            exact
            path="/changelog"
            element={
              <RouteSEO>
                <PublicChangeLog />
              </RouteSEO>
            }
          /> */}

            {/* Waitlist */}
            {/* <Route
              exact
              path="/waitlist"
              element={
                <RouteSEO>
                  <WaitList />
                </RouteSEO>
              }
            /> */}

            {/* Office Hub */}
            <Route
              exact
              path="/office-hub"
              element={
                <RouteSEO>
                  <OfficeHub />
                </RouteSEO>
              }
            />

            {/* Task Management */}
            <Route
              exact
              path="/features/task-management"
              element={
                <RouteSEO>
                  <TaskManagement />
                </RouteSEO>
              }
            />

            {/* Solution Pages */}
            <Route
              exact
              path="/solutions/ca-firms"
              element={
                <RouteSEO>
                  <CAFirmsSolutionPage />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/solutions/tax-consultants"
              element={
                <RouteSEO>
                  <TaxConsultantsPage />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/solutions/advocates"
              element={
                <RouteSEO>
                  <AdvocatesPage />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/solutions/professional-services"
              element={
                <RouteSEO>
                  <ProfessionalServicesPage />
                </RouteSEO>
              }
            />

            {/* SEO Feature Pages */}
            <Route
              exact
              path="/features/client-wise-work-tracking"
              element={
                <RouteSEO>
                  <ClientWiseWorkTracking />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/features/fy-period-tracking"
              element={
                <RouteSEO>
                  <FYPeriodTracking />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/features/document-collection"
              element={
                <RouteSEO>
                  <DocumentCollection />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/features/review-approval-workflow"
              element={
                <RouteSEO>
                  <ReviewApprovalWorkflow />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/features/deadline-reminders"
              element={
                <RouteSEO>
                  <DeadlineReminders />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/features/closure-proof"
              element={
                <RouteSEO>
                  <ClosureProof />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/features/audit-trail"
              element={
                <RouteSEO>
                  <AuditTrail />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/features/mcp-integration"
              element={
                <RouteSEO>
                  {/* <McpIntegration /> */}
                </RouteSEO>
              }
            />

            {/* Comparison Pages */}
            <Route
              exact
              path="/compare/excel-vs-simplifyte"
              element={
                <RouteSEO>
                  <ExcelVsSimplifyte />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/compare/whatsapp-vs-simplifyte"
              element={
                <RouteSEO>
                  <WhatsAppVsSimplifyte />
                </RouteSEO>
              }
            />
            <Route
              exact
              path="/compare/generic-task-tools-vs-simplifyte"
              element={
                <RouteSEO>
                  <GenericTaskToolsVsSimplifyte />
                </RouteSEO>
              }
            />
          </Routes>
        </BrowserRouter>
      </DataProvider>
    </HelmetProvider>
  );
}
